module.exports = __webpack_public_path__ + "img/login_succ1.8060d712.png";